import { users } from '@/services/users';

const initialResetPasswordModal = { show: false, target: null };

export default {
	namespaced: true,

	state: {
		resetPasswordModal: { ...initialResetPasswordModal },
		resetPasswordLoading: false,
	},

	getters: {
		resetPasswordModal: (state) => state.resetPasswordModal,
		resetPasswordLoading: (state) => state.resetPasswordLoading,
	},

	mutations: {
		SET_RESET_PASSWORD_MODAL(state, modal) {
			state.resetPasswordModal = { ...initialResetPasswordModal, ...modal };
		},
		CLOSE_RESET_PASSWORD_MODAL(state) {
			state.resetPasswordModal.show = false;
		},
		SET_RESET_PASSWORD_LOADING(state, value) {
			state.resetPasswordLoading = value;
		},
	},

	actions: {
		openResetPasswordModal({ commit }, { id, name }) {
			commit('SET_RESET_PASSWORD_MODAL', { show: true, target: { id, name } });
		},

		closeResetPasswordModal({ commit }) {
			commit('CLOSE_RESET_PASSWORD_MODAL');
		},

		async confirmResetPassword({ state, commit }, reason) {
			commit('SET_RESET_PASSWORD_LOADING', true);
			try {
				await users.resetPassword(state.resetPasswordModal.target.id, { reason });
			} catch (error) {
				console.warn('[userActions/confirmResetPassword]', error);
				throw error;
			} finally {
				commit('SET_RESET_PASSWORD_LOADING', false);
			}
		},
	},
};
